import {
  DEFAULT_IMAGE_NODE_HEIGHT,
  DEFAULT_IMAGE_NODE_WIDTH,
} from "@zapier/canvas-constants";
import { z } from "zod";

const imageSchema = z.object({
  imageWidth: z.number().int("The image width must be an integer").min(1),
  imageHeight: z.number().int("The image height must be an integer").min(1),
});

/**
 * Calculates node dimensions based on image dimensions
 * Padding is 12px on each side = 24px total
 */
export function calculateNodeDimensions(
  imageWidth: number,
  imageHeight: number,
): { width: number; height: number } {
  imageSchema.parse({ imageWidth, imageHeight });

  const PADDING = 24; // 12px on each side
  const MAX_WIDTH = DEFAULT_IMAGE_NODE_WIDTH;
  const MAX_HEIGHT = DEFAULT_IMAGE_NODE_HEIGHT;

  // Small images: use natural size + padding
  if (imageWidth <= MAX_WIDTH && imageHeight <= MAX_HEIGHT) {
    return {
      width: Math.round(imageWidth) + PADDING,
      height: Math.round(imageHeight) + PADDING,
    };
  }

  // Large images: scale down proportionally to fit within MAX_WIDTH × MAX_HEIGHT
  const scale = Math.min(MAX_WIDTH / imageWidth, MAX_HEIGHT / imageHeight);
  const scaledWidth = Math.round(imageWidth * scale);
  const scaledHeight = Math.round(imageHeight * scale);

  return {
    width: scaledWidth + PADDING,
    height: scaledHeight + PADDING,
  };
}
